import React, {Component } from 'react';
import PerfilForm          from './perfil_form';
import '../../../css/professor/style_perfil.css';


export default  class Perfil extends Component {
    
    render() {
        return (
            <div className="container-bg">
            
                    <PerfilForm/>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/professor/perfil/perfil.js